






























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
@Component({
})
export default class Calendario extends Vue {
    //  Datepicker
    private picker: any = '';
    private today = new Date().toISOString().slice(0, 10);
    private date = new Date();
    private endDate = new Date(this.date.getFullYear(), this.date.getMonth() + 3, 0).toISOString().slice(0, 10);
    private errorDias = false;
    private mensaje = 'Seleccionar día (' + this.picker.split('-').reverse().join('/') + ')';
    //  Days
    private altaD: any = [];
    private mediaD: any = [];
    private bajaD: any = [];
    private sinD: any = [];
    private month = null;
    private months = '';
    //  Colors
    private colorAlta = '#46C126';
    private colorBaja = '#F4A01E';
    private colorMedia = '#F6EF1E';
    private colorSin = '#EE3424';
    private data = { tienda: '', tiempo: 180, anio: '', mes: '', numMasc: -1, raza: '', origen: '' };
    private dias: any = [];
    private tiendaSelected = this.$store.getters.tiendaElegidaNombre;
    private mascotasSelected: any = this.$store.getters.mascotasCita;
    private serviciosSelected: any = this.$store.getters.serviciosText;

    private dialogCalendario = false;
    private paso = 4;
    private valid = true;
    private dialogConfirm = false;


    // Ir atrás 
    private async goBack() {
      history.back();
    }

    private unlock() {
      if (this.$store.getters.user !== null && this.$store.getters.user !== undefined && this.$store.getters.user !== '') {
        const idCitas: any = [];
        let data = { idCliente: this.$store.getters.user, idCita: [] };
        for (const id of this.$store.getters.idCitaBloqueo) {
          idCitas.push(id.ID_CITA);
        }
        if (idCitas.length > 0) { // Hay citas
          data.idCita = idCitas;
          const promise = this.$store.dispatch('desbloquearHorarioCita', data);
          promise.then(async (val) => {
            if (val === 200) {
              return true;
            }
          });
        } else {
          return true;
        }
      } else {
        return false;
      }
    }

    // Ir a Home
    private async home() {
      this.unlock();
      if (await this.$store.dispatch('isDefined', this.$store.getters.idCallCenter)) {
        this.$store.dispatch('resetAll');
        this.$store.commit('setUser', undefined);
        this.$router.push('/callCenter/clubpetco');
      } else {
        this.$store.dispatch('resetAll');
        this.$router.push('/tiendas');
      }
    }

    @Watch('dias')
    private onDates(fechas: any) {
      if (fechas.length === 0) {
        this.dialogCalendario = true;
      } else {
        this.dialogCalendario = false;
      }
    }

    @Watch('month')
    private onMonthChanged(newMonth: any) {
      const [year, month] = newMonth.split('-');
      this.data.mes = month;
      this.data.anio = year;
      const services = this.getServicesData();
      const promise = this.$store.dispatch('getCalendario', { servicios: services, ...this.data });
      //  Guardamos en variable
      promise.then((value) => {
        this.errorDias = false;
        this.dias = value;
        this.creaEventos(this.dias);
        if (this.fecha !== undefined && this.fecha !== '') {
          const anioA = this.fecha.substring(0, 4);
          const mesA = this.fecha.substring(4, 6);
          const diaA = this.fecha.substring(6, 8);
          this.picker = anioA + '-' + mesA + '-' + diaA;
        } else {
          this.picker = '';
        }
        if (this.sinD.includes(this.today.substring(5, 10))) {
          this.picker = '';
        }
      })
      .catch((error) => {
          this.errorDias = true;
      });

    }

    private functionEvents(date: any) {
      const [, month, day] = date.split('-');
      if (this.altaD.includes(month + '-' + day)) {
        return this.colorAlta;
      } else if (this.mediaD.includes(month + '-' + day)) {
        return this.colorMedia;
      } else if (this.bajaD.includes(month + '-' + day)) {
        return this.colorBaja;
      } else if (this.sinD.includes(month + '-' + day)) {
        return this.colorSin;
      } else {
        return false;
      }
    }

    private restrictDays(val: any) {
      if (this.sinD.indexOf(val.substring(5, 10)) === -1) {
        return true;
      }
      return false;
    }

    private creaEventos(data: any) {
      this.altaD = [];
      this.mediaD = [];
      this.bajaD = [];
      this.sinD = [];
      const alta = [];
      const media = [];
      const baja = [];
      const sin = [];
      const todos = [];
      if (data.length > 0) {
        for (const d of data) {
          if (d.DISPONIBILIDAD === '1') {
            this.altaD.push(d.DIA[4] + d.DIA[5] + '-' + d.DIA[6] + d.DIA[7]);
          } else if (d.DISPONIBILIDAD === '2') {
            this.mediaD.push(d.DIA[4] + d.DIA[5] + '-' + d.DIA[6] + d.DIA[7]);
          } else if (d.DISPONIBILIDAD === '3') {
            this.bajaD.push(d.DIA[4] + d.DIA[5] + '-' + d.DIA[6] + d.DIA[7]);
          } else if (d.DISPONIBILIDAD === '4') {
            this.sinD.push(d.DIA[4] + d.DIA[5] + '-' + d.DIA[6] + d.DIA[7]);
          }
        }
      }
    }
    private isDefined(param: any) {
        return param !== null && param !== undefined && param !== '';
    }
    // Escoger horario (click en el día)
    private async irAHorarios(){
      let bandera = this.$store.getters.bandera;
      // this.valid = false;
      if (bandera !== 8 && bandera !== 9 && bandera !== 10 && bandera !== 11) { // Flujo normal
        this.$store.commit('setTimeOut', 0);
        this.$store.dispatch('selectFecha',this.picker.split('-').join(''));
        this.$store.dispatch('updateBandera', 5);
        this.$router.push(this.isDefined(this.$store.getters.idCallCenter) ? '/callCenter/horarios' : '/horarios');
      } else {
        //Cambio de Tienda, de mascota o de servicios o de fecha
        this.$store.commit('setTimeOut', 0);
        this.$store.dispatch('selectFecha',this.picker.split('-').join(''));
        this.$router.push(this.isDefined(this.$store.getters.idCallCenter) ? '/callCenter/horarios' : '/horarios');
      }
    }
    private get fecha() {
      return this.$store.getters.fecha;
    }

    private getServicesData(): any[] {
      const serviciosData = this.$store.getters.getTiposServicio;
      console.log(serviciosData);
      const serviciosT = Object.keys(serviciosData);
      const services: any[] = [];
      serviciosT.forEach(x => {
        services.push({
          idMascota: x,
          servicio: serviciosData[x].servicio
        });
      });
      return services;
    }

    private async created() {
      const fechaActual = new Date();
      this.data.tienda = this.$store.getters.tiendaElegidaID;
      this.data.tiempo = this.$store.getters.tiempo;
      this.data.anio = String(fechaActual.getFullYear());
      //  Mes actual
      const mes = fechaActual.getMonth() + 1;
      //  Colocamos un cero antes del número de mes, si es que es menor a 10
      if (mes < 10) {
        this.data.mes = '0' + String(mes);
      } else {
        this.data.mes = String(mes);
      }
      this.data.numMasc = this.$store.getters.mascotasCita.length;
      this.data.raza = this.$store.getters.mascotasCita[0].TIPO;
      this.data.origen = '0';
      //  Revisa que todos los tipos de mascota sean iguales.
      const services = this.getServicesData();
      const promise = this.$store.dispatch('getCalendario', {...this.data, servicios: services});
      promise.then((value) => {
        this.errorDias = false;
        this.dias = value;
        this.creaEventos(this.dias);
        if (this.fecha !== undefined && this.fecha !== '') {
          const anioA = this.fecha.substring(0, 4);
          const mesA = this.fecha.substring(4, 6);
          const diaA = this.fecha.substring(6, 8);
          this.picker = anioA + '-' + mesA + '-' + diaA;
        } else {
          this.picker = '';
        }
        if (this.sinD.includes(this.today.substring(5, 10))) {
          this.picker = '';
        }
      })
      .catch((error) => {
        this.errorDias = true;
      });
    }
  }
